import API_ROUTES, { REPORT_AI_BASE_URL } from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class ReportAIService {

  static ESGHighglightsStreamedAPIURL = REPORT_AI_BASE_URL + API_ROUTES.REPORT_AI.STREAM_ESG_HIGHLIGHTS;
  static ReportingOverviewStreamedAPIURL = REPORT_AI_BASE_URL + API_ROUTES.REPORT_AI.STREAM_REPORTING_OVERVIEW;
  static ESGSectionStreamedAPIURL = REPORT_AI_BASE_URL + API_ROUTES.REPORT_AI.STREAM_ESG;
  static ChatwWithDataStreamedAPIURL = REPORT_AI_BASE_URL + API_ROUTES.REPORT_AI.CHAT_WITH_DATA;
  static ChatWithDataStreamedAPIURLNew = REPORT_AI_BASE_URL + API_ROUTES.REPORT_AI.CHAT_WITH_DATA_NEW;
  static ReportContentGenStreamedAPIURL = REPORT_AI_BASE_URL + API_ROUTES.REPORT_AI.REPORT_CONTENT_GEN_NEW;
 
  static generateTextForReportingOverview(payload) {
    return HttpUtil.postForReportAI(API_ROUTES.REPORT_AI.REPORTING_OVERVIEW, payload);
  }

  static generateTextForESGHighlights(payload) {
    return HttpUtil.postForReportAI(API_ROUTES.REPORT_AI.ESG_HIGHLIGHTS, payload);
  }

  static checkJobStatus(jobId) {
    return HttpUtil.getFromReportAI(API_ROUTES.REPORT_AI.CHECK_JOB_STATUS.replace('<jobId>', jobId), {});
  }

  static collectReportData(jobId) {
    return HttpUtil.getFromReportAI(API_ROUTES.REPORT_AI.COLLECT_REPORT_DATA.replace('<jobId>', jobId), {});
  }

  static getRefinedTextForMaterialTopic(payload) {
    return HttpUtil.postForReportAI(API_ROUTES.REPORT_AI.MATERIAL_TOPIC, payload);
  }

  static getPersonalities() {
    return HttpUtil.getFromReportAI(API_ROUTES.REPORT_AI.GET_PERSONALITIES);
  } 

  static getCompanyPersonality(companyId) {
    return HttpUtil.getFromReportAI(API_ROUTES.REPORT_AI.GET_COMPANY_PERSONALIIES.replace('<companyId>', companyId));
  } 

  static updateCompanyPersonality(payload) {
    return HttpUtil.putForReportAI(API_ROUTES.REPORT_AI.UPDATE_COMPANY_PERSONALITY, payload);
  }

  static getReportSections() {
    return HttpUtil.getFromReportAI(API_ROUTES.REPORT_AI.GET_SECTIONS);
  }

  static getCompanySections(companyId) {
    return HttpUtil.getFromReportAI(API_ROUTES.REPORT_AI.GET_COMPANY_SECTIONS.replace('<companyId>', companyId));
  }

  static updateCompanySections(payload) {
    return HttpUtil.putForReportAI(API_ROUTES.REPORT_AI.UPDATE_COMPANY_SECTIONS, payload);
  }

  static chatWithData(payload) {
    return HttpUtil.postForReportAI(API_ROUTES.REPORT_AI.CHAT_WITH_DATA, payload);
  }

  static getStyles() {
    return HttpUtil.getFromReportAI(API_ROUTES.REPORT_AI.GET_STYLES);
  } 

  static getCompanyStyles(companyId) {
    return HttpUtil.getFromReportAI(API_ROUTES.REPORT_AI.GET_COMPANY_STYLES.replace('<companyId>', companyId));
  } 

  static updateCompanyStyles(payload) {
    return HttpUtil.putForReportAI(API_ROUTES.REPORT_AI.UPDATE_COMPANY_STYLES, payload);
  }

  static getTones() {
    return HttpUtil.getFromReportAI(API_ROUTES.REPORT_AI.GET_TONES);
  } 

  static getCompanyTones(companyId) {
    return HttpUtil.getFromReportAI(API_ROUTES.REPORT_AI.GET_COMPANY_TONES.replace('<companyId>', companyId));
  } 

  static updateCompanyTones(payload) {
    return HttpUtil.putForReportAI(API_ROUTES.REPORT_AI.UPDATE_COMPANY_TONES, payload);
  }

  static feedback(payload) {
    return HttpUtil.postForReportAI(API_ROUTES.REPORT_AI.FEEDBACK, payload);
  }

  static feedbackFromChatBot(payload) {
    return HttpUtil.postForReportAI(API_ROUTES.REPORT_AI.FEEDBACK_FROM_CHAT_BOT, payload);
  }
 
  static getHistory(companyId,userId,startLimit,endLimit) {
    return HttpUtil.getFromReportAI(API_ROUTES.REPORT_AI.GET_HISTORY
      .replace('<companyId>', companyId)
      .replace('<userId>',userId)
      .replace('<startLimit>',startLimit)
      .replace('<endLimit>',endLimit)
      
      );
  }

  static deleteChatHistory(companyId,userId) {
    return HttpUtil.deleteForReportAI(API_ROUTES.REPORT_AI.DEL_HISTORY
      .replace('<companyId>', companyId)
      .replace('<userId>',userId)
      );
  }

  static visualize(payload, companyId, logId) {
    return HttpUtil.getFromReportAI(
      API_ROUTES.REPORT_AI.VISUALIZE.replace('<companyId>', companyId).replace('<logId>', logId), 
      payload
    );
  }

  static checkCoDraftJobStatus(jobId) {
    return HttpUtil.getFromReportAI(API_ROUTES.REPORT_AI.CHECK_CODRAFT_JOB_STATUS.replace('<jobId>', jobId), {});
  }

  static getBRSRRephrasedAnswer(payload) {
    return HttpUtil.postForReportAI(API_ROUTES.REPORT_AI.BRSR_REPHRASED_ANS, payload);
  }

  static getCWDId(payload) {
    return HttpUtil.postForReportAI(API_ROUTES.REPORT_AI.GET_CWD_ID, payload);
  }

  static clearCWDId(payload) {
    return HttpUtil.postForReportAI(API_ROUTES.REPORT_AI.CLEAR_CWD_ID, payload);
  }

  static analyzeQn(payload) {
    return HttpUtil.postForReportAI(API_ROUTES.REPORT_AI.GET_CLASSIFICATION, payload);
  }

  static setProcessQuery(payload) {
    return HttpUtil.postForReportAI(API_ROUTES.REPORT_AI.PROCESS_NEW, payload);
  }

  static getRefinedTextForMaterialTopicESRS(payload) {
    return HttpUtil.postForReportAI(API_ROUTES.REPORT_AI.MATERIAL_TOPIC_ESRS, payload);
  }

  static uploadFileForExtraction(file) {
    return HttpUtil.postForReportAI(API_ROUTES.REPORT_AI.FILE_UPLOAD_EXTRACT, file);
  }

  static getFilesExtraction(companyId) {
    return HttpUtil.getFromReportAI(API_ROUTES.REPORT_AI.GET_FILE_UPLOAD.replace('<companyId>', companyId), {});
  }
}
